import { KinerjaPeriod } from 'types/kinerja'

import type { KinerjaUtamaDetail, KinerjaSelection } from 'types/kinerja'

/**
 * @deprecated use <CardPeriod /> instead, make sure `enableMultiplePeriodSupport` is set to `true`
 *
 * @param {KinerjaPeriod} period
 * @returns {("Juli - Desember" | "Januari - Juni")}
 */
export const translateSKPPeriod = (period: KinerjaPeriod) => {
  if (period === KinerjaPeriod.SEMESTER_2) return 'Juli - Desember'

  return 'Januari - Juni'
}

export const translateTargetWaktu = (targetWaktu: number) => {
  if (!targetWaktu) return '-'

  switch (targetWaktu) {
    case 6:
      return 'Per semester'
    case 12:
      return 'Per tahun'
    default:
      return `${targetWaktu} bulan`
  }
}

export const mapKuantitas = (
  options: KinerjaUtamaDetail[],
  value: KinerjaSelection | null | undefined
): KinerjaUtamaDetail | null => {
  if (value == null) return null

  const kinerja = options.find((option) => option.id === value.id)

  if (!kinerja) return null

  return {
    ...kinerja,
    targetKuantitas: kinerja.targetKuantitasMin
      ? `${value.kuantitas} kegiatan`
      : kinerja.targetKuantitas,
  }
}

export interface MappedValue<T> {
  before: T | null
  after: T | null
  beforeIndex: number | null
  index: number
}

export function mapChangedValues<T, U>(
  originalValues: T[],
  modifiedValues: T[],
  predicate: (value: T | null) => U
): MappedValue<T>[] {
  const mappedValues = modifiedValues.map((value, index) => ({
    before: null,
    beforeIndex: null,
    after: value,
    index,
  }))

  originalValues.forEach((value, index) => {
    // search if the value is in the modifiedValues
    const foundIndex = modifiedValues.findIndex(
      (modifiedValue) => predicate(modifiedValue) === predicate(value)
    )

    // if found and not same index, set the "before"
    if (foundIndex !== -1) {
      mappedValues[foundIndex].before = value
      mappedValues[foundIndex].beforeIndex = index
    }
  })

  return mappedValues
}
